import { CartEvents, ShopifyCartURLs } from '../../../scripts/util/cartEvents';

let freeShippingAmount;
let shippingPlaceholder;
let giftPlaceholder;

let $counterCaptionBelow = document.querySelector('.counter__caption--below');
let $counterCaptionAboveInitial = document.querySelector('.counter__caption--above');

if ($counterCaptionBelow) {
  shippingPlaceholder = $counterCaptionBelow.dataset.freeShippingText;
  giftPlaceholder = $counterCaptionBelow.dataset.freeGiftText;
}

let freeShippingDisabled = $counterCaptionAboveInitial.dataset.freeShippingDisabled;
let freeShippingEnabled = $counterCaptionAboveInitial.dataset.freeShippingEnabled;
let freeGiftDisabled = $counterCaptionAboveInitial.dataset.freeGiftDisabled;
let freeGiftShippingEnabled = $counterCaptionAboveInitial.dataset.freeGiftShippingEnabled;

let cartFetched = false;

export function shippingGiftCalculatorInit() {
  let giftAmount = Number(document.querySelector('.cart-countdown').dataset.minGift).toFixed(2);
  freeShippingAmount = Number(sessionStorage.getItem('CountryMinFreeShipping')).toFixed(2);
  let cartValue;

  if (!cartFetched) {
    jQuery.ajax({
      url: '/cart.json',
      dataType: 'jsonp',
      success: function (data) {
        cartValue = (data.items_subtotal_price / 100).toFixed(2);
        if (giftAmount) {
          dividerPosition(freeShippingAmount, giftAmount, cartValue);
          messageControler(freeShippingAmount, giftAmount, cartValue);
        } else {
          messageControler(freeShippingAmount, 0, cartValue);
          dividerPosition(freeShippingAmount, 0, cartValue);
        }
      },
      error: function (jxhr, status, err) {
        console.log('Error, status = ' + status + ', err = ' + err);
      },
    });
    cartFetched = true;
  }
}

function dividerPosition(freeShippingAmount, giftAmount, cartValue) {
  if (giftAmount > 0) {
    let divider = document.querySelector('.progress-bar__free-gift--line');
    let max;
    let dividerPercentage;
    let dividerTextFirst = document.querySelector('.counter-progress__placeholder--first');
    let dividerTextLast = document.querySelector('.counter-progress__placeholder--last');

    if (Math.round(freeShippingAmount * 100) > Math.round(giftAmount * 100)) {
      dividerPercentage = ((giftAmount / freeShippingAmount) * 100).toFixed(2);
      dividerTextFirst.innerHTML = giftPlaceholder;
      dividerTextLast.innerHTML = shippingPlaceholder;

      max = freeShippingAmount;
    } else {
      dividerPercentage = ((freeShippingAmount / giftAmount) * 100).toFixed(2);
      dividerTextFirst.innerHTML = shippingPlaceholder;
      dividerTextLast.innerHTML = giftPlaceholder;
      max = giftAmount;
    }

    divider.style.left = dividerPercentage + '%';
    dividerTextFirst.style.flexBasis = dividerPercentage + '%';
    animateProgressBar(cartValue, max);
  } else {
    animateProgressBar(cartValue, freeShippingAmount);
  }
}

function animateProgressBar(cartValue, max) {
  let progressBar = document.querySelector('.progress-bar__filling');
  let progressWidth = (cartValue / max) * 100;

  if (progressBar) {
    progressBar.style.width = progressWidth + '%';
    console.log('Progress bar updated');
  } else {
    console.log('Progress bar element not found');
  }
}

function stringReplace(initialText, difference) {
  return initialText.replace('XXXX', Math.abs(difference).toFixed(2));
}

function messageControler(freeShippingAmount, giftAmount, cartValue) {
  let firstMessage;
  let secondMessage;
  let thirdMessage;
  let $counterCaptionAbove = document.querySelector('.counter__caption--above');

  if (giftAmount > 0) {
    if (Math.round(freeShippingAmount * 100) > Math.round(giftAmount * 100)) {
      firstMessage = freeGiftDisabled;
      secondMessage = freeShippingDisabled;
      thirdMessage = freeGiftShippingEnabled;

      if (Math.round(cartValue * 100) > Math.round(freeShippingAmount * 100)) {
        $counterCaptionAbove.innerHTML = thirdMessage;
      } else if (Math.round(cartValue * 100) > Math.round(giftAmount * 100)) {
        let difference = cartValue - freeShippingAmount;
        $counterCaptionAbove.innerHTML = stringReplace(secondMessage, difference);
      } else {
        let difference = cartValue - giftAmount;
        $counterCaptionAbove.innerHTML = stringReplace(firstMessage, difference);
      }
    } else {
      firstMessage = freeShippingDisabled;
      secondMessage = freeGiftDisabled;
      thirdMessage = freeGiftShippingEnabled;

      if (Math.round(cartValue * 100) > Math.round(giftAmount * 100)) {
        $counterCaptionAbove.innerHTML = thirdMessage;
      } else if (Math.round(cartValue * 100) > Math.round(freeShippingAmount * 100)) {
        let difference = cartValue - giftAmount;
        $counterCaptionAbove.innerHTML = stringReplace(secondMessage, difference);
      } else {
        let difference = cartValue - freeShippingAmount;
        $counterCaptionAbove.innerHTML = stringReplace(firstMessage, difference);
      }
    }
  } else {
    firstMessage = freeShippingDisabled;
    secondMessage = freeShippingEnabled;

    if (Math.round(cartValue * 100) > Math.round(freeShippingAmount * 100)) {
      $counterCaptionAbove.innerHTML = secondMessage;
    } else {
      let difference = cartValue - freeShippingAmount;
      $counterCaptionAbove.innerHTML = stringReplace(firstMessage, difference);
    }
  }
}

(function () {
  if (!window || !window.Shopify) return;

  function isShopifyCartURL(url) {
    if (!url || url.href?.includes('?page=')) return false;
    const path = url.split('/').pop();
    return ShopifyCartURLs.includes(`/cart/${path}`);
  }

  function updateType(url) {
    if (!url) return false;
    if (url.includes('cart/add')) {
      return 'add';
    } else if (url.includes('cart/update')) {
      return 'update';
    } else if (url.includes('cart/change')) {
      return 'change';
    } else if (url.includes('cart/clear')) {
      return 'clear';
    } else return false;
  }

  function dispatchEvent(url, detail) {
    if (typeof detail === 'string') {
      try {
        detail = JSON.parse(detail);
      } catch {}
    }

    window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
    const type = updateType(url);
    switch (type) {
      case 'add':
        window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
        break;
      case 'update':
        window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
        break;
      case 'change':
        window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
        break;
      case 'clear':
        window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
        break;
      default:
        break;
    }
  }

  function XHROverride() {
    if (!window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
      const url = arguments[1];
      this.addEventListener('load', function () {
        if (isShopifyCartURL(url)) {
          dispatchEvent(url, this.response);
        }
      });
      return originalOpen.apply(this, arguments);
    };
  }

  function fetchOverride() {
    if (!window.fetch || typeof window.fetch !== 'function') return;
    const originalFetch = window.fetch;
    window.fetch = function () {
      const argument = typeof arguments[0] === 'string' ? arguments[0] : arguments[0].url;
      const response = originalFetch.apply(this, arguments);

      if (isShopifyCartURL(argument)) {
        response.then((res) => {
          res
            .clone()
            .json()
            .then((data) => dispatchEvent(res.url, data));
        });
      }

      return response;
    };
  }

  fetchOverride();
  XHROverride();
})();

window.addEventListener('rendered-cart', () => {
  console.log('rendered-cart event triggered');
  setTimeout(() => {
    cartFetched = false;
    shippingGiftCalculatorInit();
  }, 100);
  if (Nosto) Nosto.reloadCart();
});
